import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';

import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {CommonPaginationResponse, CommonResponse, PaginateResponse, processNormal, processPagination} from '../common/response.model';
import {ErrorHandlingService} from '../common/error-handling.service';
import {MedicalSpeciality} from './medical-speciality.model';
import {Observable} from 'rxjs';

@Injectable()
export class MedicalSpecialityService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }

  listAll(filter = ''): Observable<MedicalSpeciality[]> {
    let params = new HttpParams().append('no-paginate', '1');
    if (filter !== '') { params = params.append('filter', filter); }

    return this.http.get<CommonResponse<MedicalSpeciality[]>>(
      environment.apiUrl + 'medical-specialities',
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  listPaginated(page, per_page, filter = ''): Observable<PaginateResponse<MedicalSpeciality[]>> {

    let params = new HttpParams().append('paginate_per_page', per_page.toString()).append('page', page);
    if (filter !== '') { params = params.append('filter', filter); }

    return this.http.get<CommonPaginationResponse<PaginateResponse<MedicalSpeciality[]>>>(
      environment.apiUrl + 'medical-specialities',
      {
        params
      }
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  add(speciality: MedicalSpeciality): Observable<MedicalSpeciality> {

    return this.http.post<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'medical-specialities',
      {
        name: speciality.name,
        description: speciality.description,
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  show(id): Observable<MedicalSpeciality> {

    return this.http.get<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'medical-specialities/' + id
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  edit(speciality: MedicalSpeciality): Observable<MedicalSpeciality> {

    return this.http.put<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'medical-specialities/' + speciality.id,
      {
        name: speciality.name,
        description: speciality.description,
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  delete(id: string): Observable<MedicalSpeciality> {

    return this.http.delete<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'medical-specialities/' + id
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}
